export default "__VITE_ASSET__ClBs5swz__"